module.exports = __webpack_public_path__ + "img/earning-1.1542df45.svg";